<template>
  <div
    class="test-information"
    v-if="testData.type_id"
    ref="topic"
    :draggable="move && Boolean(testData.material_id)"
    @dragstart.stop="boxDragStart($event)"
    @dragend.stop="boxDragEnd($event)"
    @click="boxDragClick($event)"
  >
    <div class="disabledView"></div>
    <div class="test-stem-top" v-if="testHeadView">
      <ul class="test-stem-top-left">
        <li class="test-id" v-if="testOptions.testId" v-html="'ID:' + testData.id"></li>
        <li v-if="testOptions.difficult">
          <el-rate
            class="delivery"
            v-model="star"
            disabled
            :colors="['#FF8F00', '#FF8F00', '#FF9900']"
            :disabled-void-color="'rgb(198, 209, 222)'"
          ></el-rate>
        </li>
        <template v-if="infoicon">
          <li v-if="testOptions.isOriginal && testData.parent_id == 0">
            <span class="icon blue">原</span>
          </li>
          <li v-else-if="testOptions.isOriginal">
            <span class="icon blue">改</span>
          </li>
          <li v-if="testOptions.isObjective && testData.is_objective == 1">
            <span class="icon green">客</span>
          </li>
          <li v-if="testOptions.isObjective && testData.is_objective == 0">
            <span class="icon green">主</span>
          </li>
          <li v-if="testOptions.type_name && testData.type_name">
            <span class="icon yellow">{{ testData.type_name.slice(0, 1) }}</span>
          </li>
        </template>
        <template v-else>
          <li v-if="testOptions.isOriginal && testData.parent_id == 0">原题</li>
          <li v-else-if="testOptions.isOriginal">
            <b>改编题</b>
          </li>
          <li v-if="testOptions.isObjective" v-html="testData.is_objective == 1 ? '客观题' : '主观题'"></li>
          <li v-if="testOptions.type_name && testData.type_name">{{ testData.type_name }}</li>
        </template>
        <li v-if="testOptions.level_name && testData.level_name">{{ testData.level_name }}</li>
        <!-- <li v-if="testOptions.isVerify&&testData.is_verify==1" style="color:#48D06D">已审核</li> -->
        <li v-if="testOptions.isVerify && testData.is_verify == 0" style="color:#f13232">未审核</li>
        <li v-if="testOptions.freeze && testData.freeze_status == 2" style="color:#f13232">已冻结</li>
        <!-- <li v-if="testOptions.freeze&&testData.freeze_status == 1">未冻结</li> -->
        <slot name="topInfo" :data="testData" :level2="index"></slot>
      </ul>
      <p class="test-stem-top-right">
        <el-tooltip
          popper-class="xes-tooltip"
          :enterable="false"
          :placement="'top-end'"
          v-if="testOptions.source && testData.sources && testData.sources.length"
          :disabled="testData.sources && testData.sources.length <= 1"
        >
          <div slot="content" v-html="sourceTitle"></div>
          <span>来源：{{ testData.sources[0] }}</span>
        </el-tooltip>
        <slot name="topInfoRight" :data="testData" :level2="index"></slot>
      </p>
    </div>
    <!-- 展示题干部分 -->
    <div
      class="test-stem-content"
      ref="content"
      v-click="toTestShow"
      :style="{ cursor: expand ? 'pointer' : 'default' }"
    >
      <p>
        <span class="title">
          <template v-if="testOptions.paperAnalyses">
            <b
              v-if="testData.material_id"
            >{{ testData.serial_num ? `（${testData.serial_num}）.` : ''}}</b>
            <b v-else>{{ testData.test_sequence ? `${testData.test_sequence}.` : ''}}</b>
          </template>
          <b v-else-if="testData.material_id && testOptions.serial_num">（{{ testData.serial_num }}）.</b>
          <b v-else-if="testData.material_id && testOptions.index">（{{ index + 1 }}）.</b>
          <b v-else-if="testOptions.index && serial">{{ serial + 1 }}.</b>
          <b v-else-if="testOptions.index">{{ index + 1 }}.</b>
          <i v-if="testData.test_score && testOptions.score">({{ testData.test_score }}分)</i>
        </span>
        <span v-if="testOptions.stem && stem" v-for="(item, index) in stem" :key="index">
          <audioPlay
            @click.stop
            v-if="item.type == 'mp3' && testData.audio && testData.audio.stem && testData.audio.stem[item.content]"
            :src="testData.audio.stem[item.content]"
          ></audioPlay>
          <span v-else v-katex="item.name || item.content"></span>
        </span>
      </p>
      <!-- 如果是选择题展示选项 type_id:2选择题,6排序题 -->
      <table v-if="testData.type_id == 2 && tableType == 1" class="type-choice">
        <tr>
            <td width="25%" v-for="x in options" :key="x.label">
                <span v-katex="x.label + '.&nbsp;'"></span>
                <span v-if="testData.option_audio && JSON.stringify(testData.option_audio)!=='{}' && calcOptions(x.content).audio.length">
                    <span v-katex="calcOptions(x.content).text"></span>
                    <span v-for="l in calcOptions(x.content).audio">
                        <span v-if="testData.option_audio && testData.option_audio[l]">
                            <audioPlay 
                                @click.stop
                                :src="testData.option_audio[l]"
                            ></audioPlay>
                        </span>
                        <span v-else>[audio={{l}}]</span>
                    </span>
                </span>
                <span v-else v-katex="x.content"></span>
            </td>
            <!-- <td width="25%" v-for="x in options" :key="x.label" v-katex="x.label + '.&nbsp;' + x.content"></td> -->
        </tr>
    </table>

    <table v-if="testData.type_id == 2 && tableType == 2" class="type-choice">
        <tr v-for="(x, i) in options" :key="i" v-if="i % 2 == 0">
            <!-- <td width="50%" v-for="(x, n) in options" v-if="i == n || i == n - 1" :key="n" v-katex="x.label + '.&nbsp;' + x.content"></td> -->
            <td width="50%" v-for="(x, n) in options" v-if="i == n || i == n - 1" :key="n">
                <span v-katex="x.label + '.&nbsp;'"></span>
                <span v-if="testData.option_audio && JSON.stringify(testData.option_audio)!=='{}' && calcOptions(x.content).audio.length">
                    <span v-katex="calcOptions(x.content).text"></span>
                    <span v-for="l in calcOptions(x.content).audio">
                        <span v-if="testData.option_audio && testData.option_audio[l]">
                            <audioPlay 
                                @click.stop
                                :src="testData.option_audio[l]"
                            ></audioPlay>
                        </span>
                        <span v-else>[audio={{l}}]</span>
                    </span>
                </span>
                <span v-else v-katex="x.content"></span>
            </td>

        </tr>
    </table>

    <table v-if="testData.type_id == 2 && tableType == 3" class="type-choice">
        <tr v-for="x in options" :key="x.label">
            <td>
                <span v-katex="x.label + '.&nbsp;'"></span>
                <span v-if="testData.option_audio && JSON.stringify(testData.option_audio)!=='{}' && calcOptions(x.content).audio.length">
                    <span v-katex="calcOptions(x.content).text"></span>
                    <span v-for="l in calcOptions(x.content).audio">
                        <span v-if="testData.option_audio && testData.option_audio[l]">
                            <audioPlay 
                                @click.stop
                                :src="testData.option_audio[l]"
                            ></audioPlay>
                        </span>
                        <span v-else>[audio={{l}}]</span>
                    </span>
                </span>
                <span v-else v-katex="x.content"></span>
            </td>
        </tr>
    </table>

      <table v-if="testData.type_id == 6" class="type-choice">
        <tr v-for="x in options" :key="x.label">
          <td v-katex="x.label + '.&nbsp;' + x.content"></td>
        </tr>
      </table>

      <p v-if="testData.type_id == 8">
        <span
          v-for="(x, i) in options"
          :key="x.label + i"
          v-katex="x.content + '&nbsp;&nbsp;&nbsp;'"
        ></span>
      </p>
      <!-- 连线题 type_id:7 -->
      <div v-if="testData.type_id == 7" class="line-option type-choice">
        <div class="line-option-row" v-for="(row, i) in options" :key="i">
          <div class="line-option-column" v-for="(column, n) in row" :key="n">
            <span class="raw" v-katex="column.content"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 隐藏答案及解析等部分 -->
    <el-collapse-transition v-if="testExpandView">
      <div
        v-show="testShow || !expand"
        class="xes-transition-box"
        v-click="toTestShow"
        :style="{ cursor: expand ? 'pointer' : 'default' }"
      >
        <div class="clear-both" v-if="testOptions.answer">
          <p class="icon-style">答案</p>
          <span
            v-if="testData.judge_answer"
            class="type-top style-top"
            v-html="testData.judge_answer"
          ></span>
          <!-- 排序题答案 -->
          <span
            v-else-if="testData.answer3 && testData.type_id == 6"
            class="type-top style-top"
          >{{ this.testData.answer3.join(' ') }}</span>
          <!-- 连词成句 -->
          <span
            v-else-if="testData.answer3 && testData.type_id == 8"
            class="type-top style-top"
            v-for="(j, index) in testData.answer3"
            v-katex="j + '&nbsp;&nbsp;&nbsp;'"
            :key="index"
          ></span>
          <lineOption
            v-else-if="testData.answer3 && testData.type_id == 7 && (testShow || !expand)"
            :answer="testData.answer3"
            :options="options"
          ></lineOption>
          <span
            v-else-if="testData.answer3 && testData.type_id != 7"
            :class="[
                            { 'type-top style-top': testData.type_id == 1 || testData.choice_type == 2 },
                            { 'style-top': testData.type_id != 1 && testData.choice_type != 2 }
                        ]"
            v-for="(j, index) in testData.answer3"
            v-katex="j"
            :key="index"
          ></span>
          <span
            v-else-if="testData.answer"
            :class="[
                            { 'type-top style-top': testData.type_id == 1 || testData.choice_type == 2 },
                            { 'style-top': testData.type_id != 1 && testData.choice_type != 2 }
                        ]"
            v-katex="testData.answer"
          ></span>
        </div>
        <div class="clear-both" v-if="testOptions.analyze">
          <p class="icon-style">解析</p>
          <span
            v-if="Array.isArray(analytic)"
            class="style-width style-top"
            v-for="(item, index) in analytic"
            :key="index"
          >
            <audioPlay
              @click.stop
              v-if="item.type == 'mp3' && testData.analytic && testData.audio.analytic && testData.audio.analytic[item.content]"
              :src="testData.audio.analytic[item.content]"
            ></audioPlay>
            <span v-else v-katex="item.name || item.content"></span>
          </span>
        </div>
        <div
          class="clear-both"
          v-if="
                        testOptions.classify &&
                            testData.classify_ids &&
                            (testData.classify_ids.split(',').includes('2') || testData.classify_ids.split(',').includes('5'))
                    "
        >
          <p class="icon-style" v-if="testData.classify_ids.split(',').includes('5')">名师点拨</p>
          <p class="icon-style" v-else-if="testData.classify_ids.split(',').includes('2')">易错分析</p>
          <span class="style-width style-top" v-katex="testData.classify_content"></span>
        </div>
        <div class="clear-both" v-if="testOptions.knowledge && testData.knowledges">
          <p class="icon-style">知识点</p>
          <div class="style-width">
            <span
              class="icon-dot"
              :class="{ green: k.is_main == 1 }"
              v-for="(k, index) in testData.knowledges"
              :key="index"
            >{{ k.name }}</span>
          </div>
        </div>
        <div
          class="clear-both"
          v-if="testOptions.category_trees && testData.category_trees && testData.category_trees.length"
        >
          <p class="icon-style">题型树</p>
          <div class="style-width">
            <span
              class="icon-dot"
              :class="{ green: k.is_main == 1 }"
              v-for="k in testData.category_trees"
              :key="k.id"
            >{{ k.title }}</span>
          </div>
        </div>
        <slot name="middleInfo" :data="testData" :level2="index"></slot>
      </div>
    </el-collapse-transition>
    <!-- 试题操作项 -->
    <div class="operation-item">
      <ul class="operation-item-left">
        <!-- <li v-if="testOptions.use&&testData.use_count!=0" class="use-number" @click="useShow">使用：{{testData.use_count | numbers}}</li> -->
        <li v-if="testOptions.use">使用：{{ testData.use_count | numbers }}</li>
        <li v-if="testOptions.reply">作答：{{ testData.answer_count | numbers }}</li>
        <li
          v-if="testOptions.correctrate"
        >正确率：{{ testData.correct_rate ? (Number(testData.correct_rate) * 100).toFixed(0) : 0 }}%</li>
        <li v-if="testOptions.download">下载：{{ testData.down_count | numbers }}</li>
        <slot name="bottomInfo" :data="testData" :level2="index"></slot>
      </ul>
      <div class="operation-item-box">
        <slot name="bottomButtons" :data="testData" :level2="index" :fade="shadowMove"></slot>
      </div>
    </div>
    <!-- 浮动操作项 -->
    <div class="simpleTopic_operate" v-if="operatingfloat">
      <slot name="floatButtons" :data="testData" :level2="index" :fade="shadowMove"></slot>
    </div>
    <!-- 拖动释放 -->
    <div
      class="test-information-drop"
      v-if="dropView && myDropView"
      @drop.stop="boxDrop($event)"
      @dragover.stop="allDrag($event)"
      @dragenter.stop="boxDragHover($event, 1)"
      @dragleave.stop="boxDragHover($event, 0)"
    ></div>
    <!-- 动画副本 -->
    <testShadow :shadow="shadow"></testShadow>
  </div>
</template>

<script>
import Vue from 'vue'
import testShadow from './testShadow'
import audioPlay from './audioPlay'
import utils from './utils'
import lineOption from './lineOption'
export default {
  data () {
    return {
      testShow: false,
      testSourceShow: false,
      shadow: {
        show: false,
        html: '',
        type: ''
      },
      contenter: [],
      collectViewShow: false,
      adaptationViewShow: false,
      myDropView: true,
      width: 0
    }
  },
  props: [
    'testData',
    'testType',
    'index',
    'len',
    'materialInfo',
    'testOptions',
    'expand',
    'dropView',
    'move',
    'activeid',
    'operatingfloat',
    'serial',
    'infoicon',
    'paper'
  ],
  components: {
    testShadow,
    audioPlay,
    lineOption
  },
  methods: {
    calcOptions(content){
        if(content.length == 0){
            return {audio:[],text:''}
        }
        var text = content.replace(/\[audio=.*?\]/g,'')
        var audio = content.match(/\[audio=.*?\]/g)
        if(audio && audio.length != 0){
            audio = audio.map((e, index, array)=>{return e.replace('[audio=','').replace(']','')})
        } else{
            audio = []
        }
        return {audio,text}
    },
    toTestShow (state) {
      // if(this.move&&num || !this.move&&!num) return
      setTimeout(() => {
        if (typeof state == 'undefined') {
          this.testShow = !this.testShow
        } else {
          this.testShow = state
        }
        this.$emit('testOpen', this.testShow)
      })
    },
    boxDragStart (e) {
      this.myDropView = false
      e.dataTransfer.setData('aaa', '')
      this.$emit('setDropView', true)
      this.$emit('childDragStart', this.testData, this.index)
    },
    boxDragEnd (e) {
      this.myDropView = true
      this.$emit('childDragEnd', this.testData, this.index)
      this.$emit('setDropView', false)
    },
    boxDragClick (e) {
      if (!this.testData.material_id) {
        return
      }
      e.stopPropagation()
      this.$emit('childDragClick', this.testData, this.index)
    },
    allDrag (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    boxDragHover (e, type) {
      if (type == 1) {
        e.target.style.border = '1px dashed #5A75F6'
      } else {
        e.target.style = ''
      }
    },
    boxDrop (e) {
      e.target.style = ''
      this.$emit('childDrop', this.testData, this.index)
    },
    shadowMove (type) {
      this.shadow.show = true
      let str = this.$refs.topic.innerHTML
      this.shadow.html = str
      this.shadow.type = type
    },
    useShow () { }
  },
  computed: {
    star: {
      set: function (val) {
        this.property = 0
      },
      get () {
        let num = Number(this.testData.difficulty)
        num = num == 0 ? 0 : 5.5 - num / 20
        return num
      }
    },
    stem () {
      let stem = this.testData.stem
      if (this.testData.highlight && !Array.isArray(this.testData.highlight)) {
        stem = utils.setHighLight(stem, this.testData.highlight.stem_frag)
      }
      return utils.setContent(stem)
    },
    analytic () {
      return utils.setContent(this.testData.analytic)
    },
    tableType () {
      if (this.testData.tableType) return this.testData.tableType
      if (this.width == 0) return 3
      let one = Math.floor((this.width / 4 - 70) / 14)
      let two = Math.floor((this.width / 2 - 70) / 14)
      if (!this.testData.options) return
      if (this.testData.options.length > 4) return 3
      let len = 0

      if (
        this.testData.options
          .map(el => el.content)
          .join('')
          .includes('<img')
      )
        return 3
      this.testData.options.forEach(el => {
        len < el.content.length ? (len = el.content.length) : len
      })
      if (len <= one) {
        return 1
      }
      if (len <= two) {
        return 2
      }
      return 3
    },
    options () {
      // let json = this.testData.options.content
      let arr = this.testData.options
      if (this.testData.highlight && !Array.isArray(this.testData.highlight)) {
        // json = utils.setHighLight(json,this.testData.highlight.option_frag)
        arr.forEach(el => {
          el.content = utils.setHighLight(el.content, this.testData.highlight.option_frag)
        })
      }
      return arr
    },
    testHeadView () {
      let state =
        this.testOptions.testId ||
        this.testOptions.difficult ||
        this.testOptions.isOriginal ||
        this.testOptions.isObjective ||
        this.testOptions.freeze ||
        this.testOptions.source
      return state
    },
    testExpandView () {
      let state = this.testOptions.answer || this.testOptions.analyze || this.testOptions.knowledge
      return state
    },
    sourceTitle () {
      let tit = this.testData.sources.join('<br />')
      return tit
    },
    sortOption () {
      let arr = []
      this.testData.answer3.forEach(one => {
        this.options.forEach(two => {
          if (one == two.label) {
            arr.push(two.label + '. ' + two.content)
          }
        })
      })
      return arr
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.width = this.$refs.content.clientWidth
    })
  },
  filters: {
    numbers (n) {
      if (!n) return 0
      var num = Number(n)
      return num > 999 ? 999 + '+' : num
    }
  },
  directives: {
    click: {
      bind (el, binding, vnode) {
        new vueClick(el, binding, vnode)
      }
    }
  }
}
class vueClick {
  constructor(el, binding, vnode) {
    this.el = el
    this.binding = binding
    this.vnode = vnode
    this.start = { x: 0, y: 0 }
    this.end = { x: 0, y: 0 }
    this.el.addEventListener('mousedown', e => {
      this.start.x = e.offsetX
      this.start.y = e.offsetY
    })
    this.el.addEventListener('mouseup', e => {
      this.end.x = e.offsetX
      this.end.y = e.offsetY
      if (Math.abs(this.end.x - this.start.x) < 5 && Math.abs(this.end.y - this.start.y && e.button == 0) < 5) {
        this.binding.value()
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// packages/question-single/src/single.vue